import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/axios';
import { pinAuthEmail } from '../utils/authSession';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const res = await api.get('/auth/me', {
        params: { _: Date.now() },
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
      });
      const me = res.data || {};
      if (me.email) {
        pinAuthEmail(me.email);
      }
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { fetchUser(); }, [fetchUser]);

  const tenantRole = user?.tenantRole ?? null;
  // Every ReachOut role held (Admin + Manager, ...); access is their union.
  const tenantRoles = Array.isArray(user?.tenantRoles) ? user.tenantRoles : (tenantRole ? [tenantRole] : []);
  const tenantId = user?.tenantId ?? null;
  const role = tenantRole || user?.role || null;
  const entitlements = user?.entitlements && typeof user.entitlements === 'object' ? user.entitlements : {};
  const unrestricted = user?.role === 'SUPER_ADMIN' && !tenantId && !tenantRole;

  return (
    <AuthContext.Provider value={{ user, role, tenantRole, tenantRoles, tenantId, entitlements, unrestricted, isLoading, refetchUser: fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
